export default __webpack_public_path__ + "static/description-video-d-d684c5c22f788f79ebba66f8351c21cc.png";